import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

export class FeaturedProductSlider {
	static setupSlider() {
		$('.js-featured-product-slider').each(function(index) {
			let $this = $(this);
			let $parent = $(this).closest('.featured-product-slider__wrapper');
			$parent.addClass(`featured-product-slider__wrapper-${index}`);
			$parent.find('.featured-product-slider__navigation').addClass(`featured-product-slider__navigation-${index}`);
			$parent.find('.featured-product-slider__counter').addClass(`featured-product-slider__counter-${index}`);
			$this.addClass('featured-product-slider-' + index);
			let fpSliderList = [];
			let $counterContainer = $(`.featured-product-slider__counter-${index}`);

			let fpSlider = new Swiper('.featured-product-slider-' + index, {
				slidesPerView: 1,
				speed: 400,
				spaceBetween: 0,
				centeredSlides: true,
				loop: false,
				simulateTouch: true,

				navigation:  {
					nextEl: `.featured-product-slider__navigation-${index} .swiper-button-next`,
					prevEl: `.featured-product-slider__navigation-${index} .swiper-button-prev`
				},

				on: {
					init: function (swiper) {
						$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`)
					},
					slideChange: function (swiper) {
						$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`);
					}
				}
			});

			fpSliderList.push(fpSlider);
			fpSlider.init();
		});
	}


	static init() {
		FeaturedProductSlider.setupSlider();
	}
}

FeaturedProductSlider.init();
